import { createSlice } from "@reduxjs/toolkit";

const initialRouter = [];

const slice = createSlice({
  name: "router",
  initialState: {
    router: initialRouter,
  },
  reducers: {
    createRouteHistorySuccess: (state, action) => {
      const { payload } = action;
      let previous = state.router.length > 1 ? [state.router.pop()] : state.router;
      state.router = [...previous, payload];
    },
  },
});

export const createRouteHistory = (data) => async (dispatch) => {
  try {
    dispatch(createRouteHistorySuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

const { actions, reducer } = slice;

export const { createRouteHistorySuccess } = actions;

export default reducer;
